import { useMemo } from 'react';
import { useGetOffices, type Office } from '@/api';
import { SelectWithDescriptionOption } from '@/components/formBuilder/SelectComponents';

type OfficeConfigProps = {
  config?: {
    name?: string;
    label?: string;
    options?: Office[];
    [key: string]: any;
  };
};

export const useOfficeConfig = ({ config }: OfficeConfigProps = {}) => {
  const { name = 'office', ...overRides } = config ?? {};

  const { offices, isLoading } = useGetOffices();

  const formConfig = useMemo(() => {
    return {
      isConditional: true,
      conditionConfig: { field: 'location', value: 'onsite' },
      name,
      label: 'Office Address',
      type: 'select',
      isRequired: true,
      options: offices,
      containerStyles: { width: '100%' },
      placeholder: 'Select office address',
      loading: isLoading,
      valueKey: 'id',
      labelKey: 'name',
      isMulti: false,
      descKey: 'location',
      components: {
        Option: SelectWithDescriptionOption,
      },
      ...overRides,
    };
  }, [name, offices, isLoading, overRides]);

  return formConfig;
};
